import { style } from "@vanilla-extract/css";
import { vars } from "../../styles";

export const surfaceInfoText = style({
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.m,
});
